import PostFooter from "./PostFooter";
import PreHeader from "./PreHeader";

export default {
  PostFooter,
  PreHeader
};
